<div class="rv-relative scroll-box">
  <button
    *ngIf="canScrollLeft"
    class="paginate-button previous"
    type="button"
    (click)="scrollLeft()"
  >
    <riv-icon
      class="paginate-icon"
      [name]="'ChevronLeft'"
      [size]="arrowSize"
    ></riv-icon>
  </button>
  <div
    class="fading-scroll"
    #scrollable
    [ngClass]="{
      'can-scroll-left': canScrollLeft,
      'can-scroll-right': canScrollRight
    }"
    (scroll)="updateArrows()"
  >
    <div [style.width]="'fit-content'" (rivClientSize)="updateArrows()">
      <ng-content></ng-content>
    </div>
  </div>
  <button
    *ngIf="canScrollRight"
    class="paginate-button next"
    type="button"
    (click)="scrollRight()"
  >
    <riv-icon
      class="paginate-icon"
      [name]="'ChevronRight'"
      [size]="arrowSize"
    ></riv-icon>
  </button>
</div>
